/** TanStack Query keys for auth-related queries. */
export const authKeys = {
  me: ["me"] as const,
};
